"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRefreshCtxTool = createRefreshCtxTool;
const path = __importStar(require("path"));
const fsExtra = __importStar(require("fs-extra"));
const getState_1 = require("../../../app/dist/getState");
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../fs/dist");
const frontmatterUtils_1 = require("../../../core/dist/frontmatterUtils");
const dist_3 = require("../../../core/dist");
const dist_4 = require("../../../app/dist");
/**
 * loom_refresh_ctx — assemble, don't generate (design D1=b).
 *
 * ctx is **global-only** (ctx-surface-parity): one loom/ctx.md per project, no scope arg.
 * No server-side inference. Two paths:
 *  - `skeleton_only` → write ONLY the pillar headings + authoring hints (no source, no
 *    summary), so the user can edit the section structure before a real generation.
 *  - default → assemble the project source, ensure the ctx shell (seed the pillar skeleton
 *    on a fresh doc; preserve the existing body's headings on an existing one), and return
 *    the source + section template for the agent to summarise, then call loom_update_doc.
 *
 * There is no human-facing stale badge for ctx (design §4): `last_refreshed` is the honest
 * recency signal, and Refresh is always available. `stale` here is only an idempotency hint
 * (source unchanged since the last generation).
 */
function createRefreshCtxTool() {
    return {
        toolDef: {
            name: 'loom_refresh_ctx',
            description: 'Prepare a (re)generation of the global ctx doc (loom/ctx.md, id loom-ctx). ctx is global-only — no scope. Pass skeleton_only:true to write ONLY the pillar headings + authoring hints (no source, no summary) so the user can edit the structure before a real generation. Otherwise assembles the project source, seeds the pillar skeleton on a fresh doc (preserves existing headings on an existing one), and returns { source, template } — summarise the source under the template sections, then call loom_update_doc on the returned ctxId. No server-side inference (works in any host). Returns stale=false when the source is unchanged since the last generation (source_hash).',
            inputSchema: {
                type: 'object',
                properties: {
                    skeleton_only: {
                        type: 'boolean',
                        description: 'Write only the pillar skeleton (headings + authoring hints), no inference — for seeding ctx.md before a real refresh.',
                    },
                },
                required: [],
            },
        },
        handle: async (root, args) => {
            const skeletonOnly = args['skeleton_only'] === true;
            const registry = new dist_2.ConfigRegistry();
            const state = await (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs: fsExtra, workspaceRoot: root });
            const source = (0, dist_4.buildCtxSource)(state);
            const sourceHash = (0, dist_4.computeSourceHash)(source);
            const target = (0, dist_4.ctxTarget)();
            const loomRoot = (0, dist_1.getActiveLoomRoot)(root);
            const filePath = path.join(loomRoot, target.relPath);
            const exists = await fsExtra.pathExists(filePath);
            let version = 1;
            let created;
            let stale = true;
            let body = `# ${target.title}\n`;
            let existingBody;
            if (exists) {
                const raw = await fsExtra.readFile(filePath, 'utf8');
                const hashMatch = raw.match(/^source_hash:\s*(\S+)/m);
                stale = !hashMatch || hashMatch[1] !== sourceHash;
                const verMatch = raw.match(/^version:\s*(\d+)/m);
                version = verMatch ? Number(verMatch[1]) : 1;
                const createdMatch = raw.match(/^created:\s*(\S+)/m);
                created = createdMatch ? createdMatch[1] : undefined;
                const bodyMatch = raw.match(/^---[\s\S]*?\n---\n?([\s\S]*)$/);
                if (bodyMatch) {
                    body = bodyMatch[1];
                    existingBody = bodyMatch[1];
                }
            }
            // The section template the agent fills: existing headings (preserve-existing)
            // when the doc exists, else the default pillars.
            const template = (0, dist_3.ctxTemplateHeadings)(existingBody);
            // ── skeleton_only: write pillar headings + hints, no source, no summary. ──
            if (skeletonOnly) {
                const fm = (0, dist_4.buildCtxFrontmatter)({ ctxId: target.ctxId, title: target.title, version, sourceHash, created });
                await fsExtra.ensureDir(path.dirname(filePath));
                await fsExtra.writeFile(filePath, `${(0, frontmatterUtils_1.serializeFrontmatter)(fm)}\n${(0, dist_3.buildCtxSkeleton)(target.title)}`, 'utf8');
                return {
                    content: [{
                            type: 'text',
                            text: JSON.stringify({ ctxId: target.ctxId, targetPath: filePath, mode: 'skeleton', seeded: true, template }, null, 2),
                        }],
                };
            }
            // (Re)write the shell only when missing or stale; an up-to-date ctx is left
            // untouched. Fresh doc → seed the pillar skeleton so the agent has a structure
            // to fill; existing doc → preserve its body (its headings are the schema). The
            // frontmatter carries the new source_hash + last_refreshed; the agent overwrites
            // the body via loom_update_doc (which preserves this frontmatter).
            if (!exists || stale) {
                const seedBody = exists ? body : (0, dist_3.buildCtxSkeleton)(target.title);
                const fm = (0, dist_4.buildCtxFrontmatter)({ ctxId: target.ctxId, title: target.title, version, sourceHash, created });
                await fsExtra.ensureDir(path.dirname(filePath));
                await fsExtra.writeFile(filePath, `${(0, frontmatterUtils_1.serializeFrontmatter)(fm)}\n${seedBody}`, 'utf8');
            }
            return {
                content: [{
                        type: 'text',
                        text: JSON.stringify({ ctxId: target.ctxId, targetPath: filePath, stale, preserveExisting: exists, template, source }, null, 2),
                    }],
            };
        },
    };
}
